import React from "react";
import Image from "next/image";

const TalentSetDesktop = () => {
  //   // State to track hover on each card

  return (
    <>
      {/* desktop version */}
      <div className="w-full xl:px-0 md:px-6 lg:!px-6  px-5 relative md:bg-bottom bg-center bg-[#071B30] md:py-14 2xl:py-16 md:block hidden">
        <div className="lg:container mx-auto 2xl:px-5 xl:px-2 lg:p-0 text-white z-50 relative">
          <h2 className="font-bold md:text-[32px] 2xl:text-[36px] text-white text-center ">
            Work Backwards from Industry Shortages & Skill Gaps to <br />{" "}
            <span className="border-[#ca7216] border-b-[4px]">
              Set Talent Up for Success
            </span>
          </h2>
          <div className="flex justify-center gap-5">
            <a href="/accounting">
              <div className="bg-white rounded-[21px] px-[19px] py-[18px] shadow-[104.544px_138.336px_48.576px_0px_rgba(4,84,175,0),67.584px_88.704px_44.352px_0px_rgba(4,84,175,0.01),38.016px_49.632px_36.96px_0px_rgba(4,84,175,0.05),16.896px_22.176px_27.456px_0px_rgba(4,84,175,0.09),4.224px_5.28px_14.784px_0px_rgba(4,84,175,0.1)] w-[268px] h-[330px] mt-12">
                <Image
                  priority
                  src="/about-us/set1.png"
                  alt="Accounting Image"
                  className="mx-auto"
                  width={222}
                  height={255}
                />
                <h2 className="text-black text-center font-bold md:text-2xl 2xl:text-[28px]">
                  Accounting
                </h2>
              </div>
            </a>
            <a href="/healthcare">
              <div className="bg-white rounded-[21px] px-[19px] py-[18px] shadow-[104.544px_138.336px_48.576px_0px_rgba(4,84,175,0),67.584px_88.704px_44.352px_0px_rgba(4,84,175,0.01),38.016px_49.632px_36.96px_0px_rgba(4,84,175,0.05),16.896px_22.176px_27.456px_0px_rgba(4,84,175,0.09),4.224px_5.28px_14.784px_0px_rgba(4,84,175,0.1)] w-[268px] h-[330px] mt-12">
                <Image
                  priority
                  src="/about-us/set2.png"
                  alt="Accounting Image"
                  className="mx-auto mt-[30px] mb-[50px]"
                  width={222}
                  height={255}
                />
                <h2 className="text-black text-center font-bold md:text-2xl 2xl:text-[28px]">
                  Healthcare
                </h2>
              </div>
            </a>

            <a href="/business">
              <div className="bg-white rounded-[21px] px-[19px] py-[18px] shadow-[104.544px_138.336px_48.576px_0px_rgba(4,84,175,0),67.584px_88.704px_44.352px_0px_rgba(4,84,175,0.01),38.016px_49.632px_36.96px_0px_rgba(4,84,175,0.05),16.896px_22.176px_27.456px_0px_rgba(4,84,175,0.09),4.224px_5.28px_14.784px_0px_rgba(4,84,175,0.1)] w-[268px] h-[330px] mt-12">
                <Image
                  priority
                  src="/about-us/set3.png"
                  alt="Accounting Image"
                  className="mx-auto mt-[30px] mb-[36px]"
                  width={222}
                  height={255}
                />
                <h2 className="text-black text-center font-bold md:text-2xl 2xl:text-[28px]">
                  Business
                </h2>
              </div>
            </a>

            <div className="bg-white rounded-[21px] px-[19px] py-[18px] shadow-[104.544px_138.336px_48.576px_0px_rgba(4,84,175,0),67.584px_88.704px_44.352px_0px_rgba(4,84,175,0.01),38.016px_49.632px_36.96px_0px_rgba(4,84,175,0.05),16.896px_22.176px_27.456px_0px_rgba(4,84,175,0.09),4.224px_5.28px_14.784px_0px_rgba(4,84,175,0.1)] w-[268px] h-[330px] mt-12">
              <Image
                priority
                src="/about-us/set4.png"
                alt="Accounting Image"
                className="mx-auto mt-[20px] mb-[40px]"
                width={222}
                height={255}
              />
              <h2 className="text-black text-center font-bold md:text-2xl 2xl:text-[28px]">
                Technology
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TalentSetDesktop;
